window.arContactFormDetailFormatter = function(value, row) {
    let html = '';
    if (row.message) {
        html += row.message;
    }
    return html;
};
